__turbopack_context__.v({
  "cardsContainer": "tGmxEq_cardsContainer",
  "container": "tGmxEq_container",
  "productActions": "tGmxEq_productActions",
  "productContent": "tGmxEq_productContent",
  "productDescription": "tGmxEq_productDescription",
  "productItem": "tGmxEq_productItem",
  "productTitle": "tGmxEq_productTitle",
  "root": "tGmxEq_root",
});
